import angular from 'angular';
import MenuToggleComponent from './menu-toggle.component';

let MenuToggleModule = angular.module('shared.components.menuToggle', [])
  .component('menuToggle', MenuToggleComponent);

export default MenuToggleModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/menu-toggle/menu-toggle.js
 **/